
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import LoadingIndicator from '../../../../core/components/Generics/LoadingIndicator.vue';
import Button from '../../../../core/components/Generics/Button.vue';
import SimpleMap from '../../../../core/components/Map/SimpleMap.vue';
import DatePickerSingle from '../../../../core/components/Generics/Dates/DatePickerSingle.vue';
import { SatellitalImage } from '../../../../../features/typescript/satellital/satellital_images';
import { showInfoSnackbar, showSuccessSnackbar, showHighCloudyConfirmDialog } from '../../../../../features/helpers/alerts-popups';
import { getNdviDiffCloudyMessage } from '../../../../../features/item_with_sinisters/helpers/high-cloudy-confirm-messages';
import HighCloudyImageBadge from '../../satellital/HighCloudyImageBadge.vue';
import { ComboSelectedOption } from 'features/core/components/Generics/Combobox/Combobox';
import Combobox from '../../../../core/components/Generics/Combobox/Combobox.vue'
import ColorQuantitySelector from '../../combos/ColorQuantitySelector.vue';
import { formatDate } from '../../../../../features/core/utils/date-handlers';
import { dateIsAfterAnother } from '../../../../../features/core/utils/dates';
import moment, { Moment } from 'moment';
import ImgZoomable from '../../../../core/components/Images/ImgZoomable.vue';
import { NDVIInfo } from '../../../../../features/typescript/satellital/layers';
@Component({
  components: { 
    Button, 
    SimpleMap, 
    LoadingIndicator, 
    DatePickerSingle,
    Combobox,
    ImgZoomable,
    ColorQuantitySelector,
    HighCloudyImageBadge,
  },
})
export default class ModalNdviDiff extends Vue {
  @Prop({ default: null }) zonifiedDate!: string | null;
  @Prop({default: null}) selectedImage: SatellitalImage;
  @Prop({default(){return []}}) bandImages: SatellitalImage[];
  @Prop({default: null}) diffInfo: NDVIInfo | null;
  @Prop({default: 3}) zonesLength: number;
  visible: boolean = true;
  modalTitle: string = 'Generar Diferencial NDVI';

  openComboboxCount: number = 0;

  selectedInitialDate: ComboSelectedOption = null;
  selectedInitialDateRv: boolean = false;

  finalDate: ComboSelectedOption = null;
  finalDateRv: boolean = false;

  scale: ComboSelectedOption | null =  null;

  mounted(){
    this.preselectZonesLength();
  }

  preselectZonesLength(){
    if(this.zonesLength > 0){
      this.scale = { id: this.zonesLength, value: this.zonesLength.toString() };
    }
  }

  get resultIsVisible(){
    let firstCondition =  this.diffInfo !== null && this.diffInfo.png_url !== null;

    let secondCondition = false;
    if(this.diffInfo !== null && this.selectedInitialDate !== null && this.finalDate !== null){
      secondCondition = (this.diffInfo.initial_date == this.selectedInitialDate['date']) && (this.diffInfo.final_date == this.finalDate['date'])
    }
    return firstCondition && secondCondition;
  }

  get hasPreviewImages(): boolean {
    const initialPreview = this.selectedInitialDate !== null && this.selectedInitialDate['png_url'];
    const finalPreview = this.finalDate !== null && this.finalDate['png_url'];
    return !!(initialPreview || finalPreview);
  }

  get allowDropdownOverflow(): boolean {
    return this.openComboboxCount > 0 || (!this.resultIsVisible && !this.hasPreviewImages);
  }

  onComboboxOpen() {
    this.openComboboxCount++;
  }

  onComboboxClose() {
    if (this.openComboboxCount > 0) {
      this.openComboboxCount--;
    }
  }

  checkIfFinalDateStillValid(){
    if(this.selectedInitialDate){
      if(this.finalDate){
        const base = moment(this.selectedInitialDate['date']);
        const fin  = moment(this.finalDate['date']);
        if(!dateIsAfterAnother(base, fin, true)){
          this.finalDate = null;
          this.finalDateRv = true;
        }
      }
    }else{
      this.finalDate = null;
      this.finalDateRv = true;
    }
  }
   


  private asMoment(opt: ComboSelectedOption | null): Moment | null {
    return opt && opt['date'] ? moment(opt['date']) : null;
  }

  get isRangeSelected(): boolean {
    return !!(this.selectedInitialDate && this.finalDate);
  }

  get isRangeValid(): boolean {
    if (!this.isRangeSelected) return true;
    const base = this.asMoment(this.selectedInitialDate)!;
    const fin  = this.asMoment(this.finalDate)!;
    return dateIsAfterAnother(base, fin, true);
  }

  get secondaryErrorText(): string {
    if (!this.isRangeSelected) return '';
    return this.isRangeValid ? '' : 'La Fecha Final debe ser posterior a la Fecha Inicial.';
  }

  get formattedBandImages(){
    if(this.bandImages.length == 0) return []

    return this.bandImages.map((image: SatellitalImage) => {
      return {
        id: image.id,
        date: image.date,
        value: formatDate(image.date, false, true),
        png_url: image.png_url,
        high_cloudy_image: image.high_cloudy_image,
      }
    })
  }

  updateselectedInitialDate(value: ComboSelectedOption){
    this.selectedInitialDate = value;
    this.checkIfFinalDateStillValid();
  }

  updateSelectedfinalDate(value: ComboSelectedOption){
    this.finalDate = value;
  }

  get hasDiffInfo(){
    //Si tengo informacion de diferencial ndvi
    return this.diffInfo !== null;
  }


  created() {
    this.preselectDates();
  }

  preselectDates(){
    if(this.hasDiffInfo) {
      this.loadInitialAndFinalFromDiffInfo();
    }else{
      this.preselectInitialDateFromSelectedImageIfNeeded();
    }
  }

  loadInitialAndFinalFromDiffInfo(){
    if(this.diffInfo == null) return;

    console.log('loadInitialAndFinalFromDiffInfo');
    
  console.log('imgs', this.formattedBandImages)
    let initialDate = this.diffInfo.initial_date;
    console.log('initialDate', initialDate);
    let finalDate = this.diffInfo.final_date;
    if(initialDate){

      let matchInitial = this.formattedBandImages.findIndex(item => item['date'] === initialDate)
      console.log('matchInitial', matchInitial);
      if(matchInitial != -1) this.selectedInitialDate = this.formattedBandImages[matchInitial];

    }



    if(finalDate){
      let matchFinal = this.formattedBandImages.findIndex(item => item['date'] === finalDate)
      if(matchFinal != -1) this.finalDate = this.formattedBandImages[matchFinal];
    }
  }

  @Watch('selectedImage')
  onSelectedImageChanged() {
    this.preselectInitialDateFromSelectedImageIfNeeded();
  }

  preselectInitialDateFromSelectedImageIfNeeded() {
  if(this.resultIsVisible) return;

    let selectedImgDate = this.selectedImage.date;

    const match = this.formattedBandImages.find(
      (opt: any) => moment(opt.date).isSame(moment(selectedImgDate))
    );

    if (match) {
      this.updateselectedInitialDate(match);
    }
  }

 

  get finalDateOptions() {
    if (!this.selectedInitialDate) return this.formattedBandImages;

    const base = moment(this.selectedInitialDate['date']);
    return this.formattedBandImages.filter(opt =>
      dateIsAfterAnother(base, moment(opt.date), true)
    );
  }

 


  async emitSave() {
    const data = {
      initial_image_id:  this.selectedInitialDate ? this.selectedInitialDate['id'] : null,
      final_image_id: this.finalDate ? this.finalDate['id'] : null,
      scale: this.scale ? this.scale.id : null
    };

    if (!data.initial_image_id) {
      showInfoSnackbar('Debe asignar la fecha Inicial');
      return; 
    }

    if (!data.final_image_id) {
      showInfoSnackbar('Debe asignar la fecha Final');
      return; 
    }

    if (!this.isRangeValid) {
      showInfoSnackbar('La Fecha Final debe ser posterior a la Fecha Inicial');
      return;
    }

    if (!this.scale) {
      showInfoSnackbar('Debe seleccionar la cantidad de colores');
      return;
    }

    const initialCloudy = this.selectedInitialDate !== null && this.selectedInitialDate['high_cloudy_image'] === true;
    const finalCloudy = this.finalDate !== null && this.finalDate['high_cloudy_image'] === true;

    if (initialCloudy || finalCloudy) {
      const confirmed = await showHighCloudyConfirmDialog(
        getNdviDiffCloudyMessage(initialCloudy, finalCloudy)
      );
      if (!confirmed) return;
    }

    this.$emit('save', data);
  }

  @Emit()
  save(data){}

  @Emit()
  closeModal() {}
}
